module.exports = __webpack_public_path__ + "static/device_tablet_apple_dark_landscape-3dd0cd97d838b04bd7cf9c5bfbc2cd56.png";